import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AdminUser {
  id: string
  email: string
  fullName: string | null
  picture: string | null
  isoftRoles: string[]
}

interface AdminStore {
  token: string | null
  user: AdminUser | null
  setSession: (token: string, user: AdminUser) => void
  clearSession: () => void
  isSessionValid: () => boolean
}

function jwtExpiry(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return typeof payload.exp === 'number' ? payload.exp : null
  } catch {
    return null
  }
}

export const useAdminStore = create<AdminStore>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      clearSession: () => set({ token: null, user: null }),
      isSessionValid: () => {
        const { token } = get()
        if (!token) return false
        const exp = jwtExpiry(token)
        if (exp === null) return false
        return Date.now() / 1000 < exp
      },
    }),
    {
      name: 'isoft-admin-session',
      onRehydrateStorage: () => (state) => {
        if (state && !state.isSessionValid()) {
          state.clearSession()
        }
      },
    },
  ),
)
